export default {"src":"/_next/static/media/circleExclamation.13cb5beb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};